import { Route, Routes } from "react-router-dom";
import InternationalWireForm from "./InternationalWireForm";
import InternationalWireReview from "./InternationalWireReview";
import { SudoProvider } from "../../../SudoContext";
import RequestOTP from "../../../SudoContext/RequestOTP";
import SubmitOTP from "../../../SudoContext/SubmitOTP";
import ReceiptScreen from "./ReceiptScreen";

const InternationalWireContainer = () => (
  <SudoProvider basename="transfer/wires/international">
    <Routes>
      <Route path="review" element={<InternationalWireReview />} />
      <Route path="sudo/request-otp" element={<RequestOTP />} />
      <Route path="sudo/submit-otp" element={<SubmitOTP />} />
      <Route path="receipt" element={<ReceiptScreen />} />
      <Route index element={<InternationalWireForm />} />
    </Routes>
  </SudoProvider>
);

export default InternationalWireContainer;
